import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';

import { Button, Modal, Text } from 'v3/components';
import Loader from 'v3/components/Loader';
import { listShippingCompanyRequestAudits } from 'v3/services/shippingCompanyRequest';

import { formatDateTime, getStatusName } from '../shared/status';

function formatUser(entry) {
  const name = entry.userName || '-';
  return entry.actor === 'CARRIER' ? `Transportadora · ${name}` : name;
}

export default function AuditModal({ show, requestId, onClose }) {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!show) return undefined;
    let ignore = false;

    async function fetchAudits() {
      setLoading(true);
      setError(null);
      try {
        const data = await listShippingCompanyRequestAudits(requestId);
        if (!ignore) setAudits(data);
      } catch (err) {
        if (!ignore) {
          setAudits([]);
          setError(err.message);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    fetchAudits();

    return () => {
      ignore = true;
    };
  }, [show, requestId, reloadKey]);

  function renderBody() {
    if (loading) {
      return (
        <div className="d-flex align-items-center py-3">
          <Loader loading />
          <Text type="label" color="gray" className="ml-2">
            Carregando auditoria...
          </Text>
        </div>
      );
    }

    if (error) {
      return (
        <div className="d-flex align-items-center py-3" data-testid="audit-error">
          <Text type="regular" color="danger" className="mr-3">
            {error}
          </Text>
          <Button variant="secondary" size="sm" onClick={() => setReloadKey((key) => key + 1)}>
            <Text color="dark" weight={500}>
              Tentar novamente
            </Text>
          </Button>
        </div>
      );
    }

    if (!audits.length) {
      return (
        <Text type="regular" color="gray" as="p" className="py-3" data-testid="audit-empty">
          Nenhuma alteração registrada
        </Text>
      );
    }

    return (
      <Table responsive size="sm" data-testid="audit-table">
        <thead>
          <tr>
            <th>Data/hora</th>
            <th>Usuário</th>
            <th>De</th>
            <th>Para</th>
            <th>Observação</th>
          </tr>
        </thead>
        <tbody>
          {audits.map((entry) => (
            <tr key={entry.id}>
              <td style={{ whiteSpace: 'nowrap' }}>{formatDateTime(entry.createdAt)}</td>
              <td>{formatUser(entry)}</td>
              <td>{entry.fromStatus ? getStatusName(entry.fromStatus) : '-'}</td>
              <td>{getStatusName(entry.toStatus)}</td>
              <td style={{ whiteSpace: 'pre-wrap' }}>{entry.observation || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  return (
    <Modal
      show={show}
      handleClose={onClose}
      size="lg"
      heading={
        <Text color="dark" type="header" weight="500">
          Auditoria da solicitação
        </Text>
      }
      body={renderBody()}
      footer={
        <Button variant="white" outlined onClick={onClose}>
          <Text weight={500} type="regular">
            Fechar
          </Text>
        </Button>
      }
    />
  );
}
